module.exports = __webpack_public_path__ + "img/Oxygen.714c4aa2.svg";